module.exports = __webpack_public_path__ + "img/solution-cockpit04-function-pic.30ac80a1.png";